import { render, staticRenderFns } from "./EditTable.vue?vue&type=template&id=776efa12&"
import script from "./EditTable.vue?vue&type=script&lang=js&"
export * from "./EditTable.vue?vue&type=script&lang=js&"
import style0 from "./EditTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776efa12')) {
      api.createRecord('776efa12', component.options)
    } else {
      api.reload('776efa12', component.options)
    }
    module.hot.accept("./EditTable.vue?vue&type=template&id=776efa12&", function () {
      api.rerender('776efa12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/OuterBoxLabelManagement_v2/components/EditTable.vue"
export default component.exports